import axios from '../../../axios';
import { setMsgInfo } from '../..';
import {
  extractLoading,
  extractSuccess,
  extractFailure,
} from '../../../reducers/dashboard/finance/bankTransactionExtractSlice';
import API from '../../api';

const baseUrl = `${API}/dashboard`;

// Shared handling for both the initial extraction and the TAN-submit step.
// Returns the response data so the caller (modal) can react to a
// `tan_required` status; never throws (errors surface as messages).
const runExtraction = (url) => (values) => async (dispatch) => {
  dispatch(extractLoading());

  try {
    const { data } = await axios.post(url, values);

    dispatch(extractSuccess(data));

    // The bank wants a TAN: hand the challenge back to the modal, no toast.
    if (data?.status === 'tan_required') {
      return data;
    }

    // Otherwise it's the per-account summary { created, skipped, errors }.
    const msg = [
      data?.detail || 'Transactions extracted and saved successfully',
      `Imported: ${data?.created ?? 0}, skipped: ${data?.skipped ?? 0}`,
    ];
    (data?.errors || []).forEach((e) => msg.push(e.detail || 'Extraction error'));

    dispatch(setMsgInfo({ success: true, msg }));
    return data;
  } catch (error) {
    const serverErrors = error.response?.data?.errors || [];
    const msg = serverErrors.length
      ? serverErrors.map((e) => e.detail || 'Extraction error')
      : [error.response?.data?.detail || 'Problem extracting the transaction'];

    dispatch(extractFailure(msg.join(' ')));
    dispatch(setMsgInfo({ success: false, msg }));
    return { status: 'error', detail: msg.join(' ') };
  }
};

export const bankTransactionExtraction = runExtraction(
  `${baseUrl}/bank_transaction_extraction`,
);

// Step 2 of the live FinTS flow: submit the user's TAN.
export const submitBankTransactionTan = runExtraction(
  `${baseUrl}/bank_transaction_tan`,
);
